import { makeStyles } from '@mui/styles'

export const useAppBarItemStyles = makeStyles(() => ({
  centerButtonText: {
    lineHeight: 1,
    textTransform: 'none',
  },
  popoverContainer: {
    minWidth: '200px',
  },
}))
